// extracted by mini-css-extract-plugin
export default {"root":"DashboardMemoryView_root-Hv8","rootChatView":"DashboardMemoryView_rootChatView-IJd"};